import { jsx } from "react/jsx-runtime";
import { Path, SVG } from "@wordpress/primitives";
var justify_center_default = /* @__PURE__ */ jsx(SVG, { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx(Path, { d: "M12.5 15v5H11v-5H4V9h7V4h1.5v5h7v6h-7Z" }) });
export {
  justify_center_default as default
};
//# sourceMappingURL=justify-center.js.map
